export const OwnerTitle = {
    MR: 'Mr',
    MISS: 'Miss',
    MRS: 'Mrs',
    MS: 'Ms'
};
